import React from "react";
import { createImages, getImages, saveImages, uploadImage } from "../api/ImageGeneration";
const GenerateImageContext = React.createContext();



const GenerateImageProvider = ({ children }) => {
  const [generatedImages, setGeneratedImages] = React.useState([]);
  const [counterGeneratedImages, setCounterGeneratedImages] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  const generateImage = async (prompt) => {
    setErrorMessage("");
    let intervalId;
    intervalId = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + 1;
        return newProgress <= 100 ? newProgress : prevProgress;
      });
    }, 2000);
    try {
      const response = await createImages(prompt);
      clearInterval(intervalId);
      if (response.data.success) {
        const imagesFromResponse = response.data.data.images;
          setGeneratedImages(
            imagesFromResponse.map((image) => {
              return {
                prompt: prompt,
                uri: image.uri,
                operationId: response.data.operationId,
                saved: false,
              };
            })
          );
          setCounterGeneratedImages(response.data.data.images.length);
      } else {
        response.data.message !== ""
          ? setErrorMessage(response.data.message)
          : setErrorMessage(
              "Ocurrió un error al generar las imágenes. Por favor espere unos minutos y vuelva a intentarlo."
            );
      }
    } catch (error) {
      setErrorMessage(
        "Ocurrió un error al generar las imágenes. Por favor espere unos minutos y vuelva a intentarlo."
      );
      console.error(error);
    } finally {
      setLoading(false);
      setProgress(100)
    }
  };

  const generateImageUrl = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    let intervalId;
   intervalId = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + 1;
        return newProgress <= 100 ? newProgress : prevProgress;
      });
    }, 2000);
    try {
      const response = await uploadImage(formData, (progressEvent) => {
      clearInterval(intervalId);
      });
      if (response?.data?.data) {
        return { url: response.data.data.uri };
      } else {
        return { url: null };
      }
    } catch (error) {
      return { url: null };
    }
    
  };

  const getImage = async (operationId, prompt) => {
    setLoading(true);
    await getImages({ operationId })
      .then((response) => {
        if (response.data.success) {
          const imagesFromResponse = response.data.data.images;

          setGeneratedImages(
            imagesFromResponse.map((image) => {
              return {
                uri: image.uri,
                operationId: operationId,
                saved: false,
              };
            })
          );

          setCounterGeneratedImages(response.data.data.images.length);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
      });
  };

  const saveImage = async (image) => {
    setSaveLoading(true);
    await saveImages(image)
      .then(() => {
        const generatedImagesToUpdate = [...generatedImages];
        const foundIndex = generatedImagesToUpdate.findIndex(
          (x) => x.uri === image.uri && x.operationId === image.operationId
        );
        generatedImagesToUpdate[foundIndex].saved = true;
        setGeneratedImages(generatedImagesToUpdate);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  };

  const resetProgressContext = (file) => {
    setProgress(0)
  }
  const resetImageGenerate = () => {
    setGeneratedImages([]);
  };




  return (
    <GenerateImageContext.Provider
      value={{
        generateImage,
        getImage,
        generatedImages,
        counterGeneratedImages,
        loading,
        saveImage,
        saveLoading,
        errorMessage,
        generateImageUrl,
        resetImageGenerate,
        progress,
        resetProgressContext
      }}
    >
      {children}
    </GenerateImageContext.Provider>
  );
};

export { GenerateImageContext, GenerateImageProvider };
